import { Component, Inject, OnInit } from '@angular/core';
import { AccountingSystem } from '@apaq/orgkit-js';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { DIALOG } from 'src/app/modules/dialog/dialog.service';

@Component({
  selector: 'app-system-selection-dialog',
  templateUrl: './system-selection-dialog.component.html',
  styleUrls: ['./system-selection-dialog.component.scss']
})
export class SystemSelectionDialogComponent implements OnInit {

  systems: {id:AccountingSystem, name: string}[] = [
    { id: 'Billy', name: 'Billy' },
    { id: 'Dinero', name: 'Dinero' },
    { id: 'Economic', name: 'E-conomic' }
  ];

  constructor(@Inject(DIALOG) private dialog: DialogRef) { }

  ngOnInit(): void {
  }

  close() {
    this.dialog.close();
  }

  select(id: string) {
    this.dialog.close(id);
  }
}
